'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Time = require('./Time');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Time).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



//////////////////
// WEBPACK FOOTER
// ./~/react-time/lib/index.js
// module id = 584
// module chunks = 0